/*
 This file is part of GNU Taler
 (C) 2019 GNUnet e.V.

 GNU Taler is free software; you can redistribute it and/or modify it under the
 terms of the GNU General Public License as published by the Free Software
 Foundation; either version 3, or (at your option) any later version.

 GNU Taler is distributed in the hope that it will be useful, but WITHOUT ANY
 WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS FOR
 A PARTICULAR PURPOSE.  See the GNU General Public License for more details.

 You should have received a copy of the GNU General Public License along with
 GNU Taler; see the file COPYING.  If not, see <http://www.gnu.org/licenses/>
 */

import * as platformCrypto from "#crypto-platform";

export function sha512(data: Uint8Array): Uint8Array {
  return platformCrypto.hashSha512(data);
}

export function hmacSha512(key: Uint8Array, message: Uint8Array): Uint8Array {
  return platformCrypto.hmacSha512(key, message);
}

export function hmacSha256(key: Uint8Array, message: Uint8Array): Uint8Array {
  return platformCrypto.hmacSha256(key, message);
}
